// @helpers
const { APIGet } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;

// @constants
const actionTypes = require('../constants/actionTypes');

const originCountry =
    window.okFunds && window.okFunds.countryCode
        ? window.okFunds.countryCode.toUpperCase()
        : 'ES';

// @commons
const apiURLBuilder = require('core/apiURLBuilder');

const globalVariablesRequest = lang => ({
    type: actionTypes.GLOBAL_VARIABLES_REQUEST,
    payload: {
        lang,
    },
});

const globalVariablesSuccess = (data = {}) => ({
    type: actionTypes.GLOBAL_VARIABLES_SUCCESS,
    payload: {
        data,
    },
});

const globalVariablesFailure = error => ({
    type: actionTypes.GLOBAL_VARIABLES_FAILURE,
    payload: {
        error,
    },
});

const getGlobalVariables = () => dispatch => {
    const requestData = {
        query: {
            language: getLanguage(),
            originCountry: originCountry,
        },
    };

    dispatch(globalVariablesRequest());

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('global-parameters'),
        requestData,
    )
        .then(response => dispatch(globalVariablesSuccess(response)))
        .catch(error => dispatch(globalVariablesFailure(error)));
};

module.exports = getGlobalVariables;
